(() => {
  const config = document.getElementById('mxpro-search-language');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  const typeConfig = document.getElementById('mxpro-product-types');
  const typeLabels = typeConfig ? JSON.parse(typeConfig.textContent) : {};
  const productType = value => Object.prototype.hasOwnProperty.call(typeLabels, value) ? typeLabels[value] : value;
  const fieldLabels = new Map([
    ['Beschikbaarheid', labels.availability], ['Availability', labels.availability],
    ['Prijs', labels.price_word], ['Price', labels.price_word],
    ['Merk', labels.brand.replace(/:\s*$/, '')], ['Vendor', labels.brand.replace(/:\s*$/, '')],
    ['Maat', labels.size], ['Size', labels.size], ['Kleur', labels.colour],
    ['Product Type', labels.product_type], ['Producttype', labels.product_type]
  ]);
  const stockLabels = new Map([['Op voorraad', labels.in_stock], ['Niet op voorraad', labels.out_of_stock]]);
  const exact = new Map([
    ['Close', labels.close], ['Clear', labels.clear], ['Clear search term', labels.clear], ['Search', labels.search],
    ['Search Result Tabs Toolbar', labels.toolbar], ['Open Filter Sidebar', labels.open_filters],
    ['Min value', labels.min], ['Max value', labels.max], ['Choose a value', labels.choose_value], ['Show result', labels.show_result],
    ['When autocomplete results are available use up and down arrows to review and enter to select', labels.instructions],
    ['Product list suggestion', labels.products]
  ]);
  const prefixes = [['Title of product is:', labels.product], ['Vendor is:', labels.brand], ['Regular price:', labels.price], ['Button:', labels.button], ['Filter by:', labels.filter_prefix], ['Choose options for product', labels.choose_options]];
  const scope = '#boost-sd__instant-search-container [aria-label], #MainContent [class*="boost-sd"][aria-label], #MainContent [id^="pf_"] [aria-label]';
  function translatedLabel(original) {
    let translated = exact.get(original) || original;
    for (const [prefix, localized] of prefixes) {
      if (original.startsWith(prefix)) translated = localized + original.slice(prefix.length);
    }
    if (original.startsWith('Filter by:')) translated = labels.filter_prefix + ' ' + (fieldLabels.get(original.slice(10).trim()) || original.slice(10).trim());
    const tab = original.match(/^(.*?) showing (\d+) results$/);
    if (tab) translated = `${tab[1]}: ${labels.results.replace('__COUNT__', tab[2])}`;
    const filter = original.match(/^Find product with (.*?) is (.*?)\. Number of products: (\d+)$/);
    if (filter) translated = `${labels.find_products} ${fieldLabels.get(filter[1]) || filter[1]}: ${filter[1] === 'Product Type' ? productType(filter[2]) : stockLabels.get(filter[2]) || filter[2]}. ${labels.product_count} ${filter[3]}`;
    if (original.startsWith('Clear ')) translated = labels.clear_filter + original.slice(5);
    translated = translated.replace(/\bVendor\b/g, labels.brand.replace(/:\s*$/, '')).replace(/\bProduct Type\b/g, labels.product_type).replace(/\bPrice\b/g, labels.price_word);
    translated = translated.replace(/^(maat|size):/i, labels.size + ':').replace(/^(kleur|color):/i, labels.colour + ':');
    return translated;
  }
  let queued = false;
  function translate() {
    queued = false;
    document.querySelectorAll('#MainContent .boost-sd__search-result-toolbar-result').forEach(element => {
      const original = element.textContent.trim();
      const match = original.match(/^Afficher\s+([\d\s.,]+)\}\s+résultats$/);
      if (match) element.textContent = labels.results.replace('__COUNT__', match[1]);
    });
    document.querySelectorAll(scope).forEach(element => {
      const original = element.getAttribute('aria-label');
      const translated = translatedLabel(original);
      if (translated !== original) element.setAttribute('aria-label', translated);
    });
    document.querySelectorAll('#MainContent .boost-sd__in-collection-search-input').forEach(element => {
      if (element.placeholder !== labels.collection_search) element.placeholder = labels.collection_search;
      if (element.getAttribute('aria-label') !== labels.collection_search) element.setAttribute('aria-label', labels.collection_search);
    });
    document.querySelectorAll('#MainContent .boost-sd__filter-option-heading, #MainContent [class$="refine-by-option"]').forEach(element => {
      const original = element.textContent.trim();
      const suffix = original.endsWith(':') ? ': ' : '';
      const translated = fieldLabels.get(original.replace(/:$/, ''));
      if (translated && element.textContent !== translated + suffix) element.textContent = translated + suffix;
    });
    document.querySelectorAll('#MainContent .boost-sd__filter-option-item-label[data-action^="pf_st_"], #MainContent [class$="refine-by-value"][metadata*="pf_st_"]').forEach(element => {
      const original = element.textContent.trim();
      const translated = stockLabels.get(original);
      if (translated && translated !== original) element.textContent = translated;
    });
    // Only change display text. Boost retains its original values, IDs and actions.
    document.querySelectorAll('#MainContent .boost-sd__filter-option-item-label[data-action^="pf_pt_product_type."], #MainContent [class$="refine-by-value"][metadata*="pf_pt_product_type"]').forEach(element => {
      const original = element.textContent.trim();
      const translated = productType(original);
      if (translated === original) return;
      element.textContent = translated;
      const button = element.closest('button, [role="button"]');
      const aria = button?.getAttribute('aria-label');
      if (aria?.includes(original)) button.setAttribute('aria-label', aria.replace(original, translated));
    });
    document.querySelectorAll('#MainContent [class$="refine-by-option"][metadata*="pf_pt_product_type"]').forEach(element => {
      if (element.textContent.trim() === 'Product Type:') element.textContent = labels.product_type + ': ';
    });
    document.querySelectorAll('#MainContent .boost-sd__product-swatch-title').forEach(element => {
      const original = element.textContent.trim();
      const translated = /^(maat|size)$/i.test(original) ? labels.size : /^(kleur|colou?r)$/i.test(original) ? labels.colour : original;
      if (translated !== original) element.textContent = translated;
    });
    document.querySelectorAll('#MainContent .boost-sd__radio-label[role="radio"]').forEach(element => {
      const checked = String(element.classList.contains('boost-sd__radio-label--selected'));
      if (element.getAttribute('aria-checked') !== checked) element.setAttribute('aria-checked', checked);
    });
    document.querySelectorAll('#boost-sd__modal-cart [aria-label]').forEach(element => {
      const original = element.getAttribute('aria-label');
      const product = element.closest('.boost-sd__cart-item-content')?.querySelector('a')?.textContent.trim() || '';
      const names = new Map([
        ['Decrease quantity', labels.decrease.replace('__PRODUCT__', product)],
        ['Increase quantity', labels.increase.replace('__PRODUCT__', product)],
        ['Remove this item', labels.remove.replace('__PRODUCT__', product)],
        ['Item quantity', labels.quantity]
      ]);
      let translated = names.get(original) || translatedLabel(original);
      if (original.startsWith('Price:')) translated = labels.price_word + original.slice(5);
      if (translated !== original) element.setAttribute('aria-label', translated);
    });
    const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (bubble) {
      const count = Number(bubble.querySelector('[aria-hidden="true"]')?.textContent);
      const hidden = bubble.querySelector('.visually-hidden');
      const translated = count === 1 ? labels.cart_count_one : labels.cart_count_other.replace(/2/, String(count));
      if (hidden && Number.isFinite(count) && hidden.textContent !== translated) hidden.textContent = translated;
    }
    document.querySelectorAll('#MainContent .boost-sd__visually-hidden').forEach(element => {
      const original = element.textContent.trim();
      let translated = original;
      if (original === 'Vendor:') translated = labels.brand;
      if (original.startsWith('Regular price ')) translated = labels.price + original.slice('Regular price'.length);
      if (translated !== original) element.textContent = translated;
    });
    const status = document.getElementById('boost-sd__isw-live-region');
    if (status) {
      const original = status.textContent.trim();
      const match = original.match(/^(\d+) results? found$/);
      const translated = match ? labels.results.replace('__COUNT__', match[1]) : original === 'No results found' ? labels.none : original;
      if (status.textContent !== translated) status.textContent = translated;
    }
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(translate); }
  }
  const observed = new WeakSet();
  function bind() {
    const ids = ['boost-sd__instant-search-container', 'boost-sd__isw-live-region', 'boost-sd__modal-cart', 'cart-icon-bubble'];
    if (document.querySelector('#MainContent [class*="boost-sd"]')) ids.push('MainContent');
    for (const id of ids) {
      const element = document.getElementById(id);
      if (element && !observed.has(element)) {
        observed.add(element);
        new MutationObserver(schedule).observe(element, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'class'] });
        schedule();
      }
    }
  }
  new MutationObserver(bind).observe(document.body, { childList: true, subtree: true });
  bind();
})();
